module.exports = __webpack_public_path__ + "img/apple.eaf91ccd.png";